document.addEventListener("DOMContentLoaded", function () {
    gsap.set('.co-article-s2 .z-ani-o', { opacity: 0, y: 40 });
    let cAS2Tl1 = gsap.timeline({ paused: true });
    cAS2Tl1.to('.co-article-s2 .z-ani-o', {
        y: 0,
        opacity: 1,
        duration: 1,
        stagger: 0.2,
        ease: "power2.inOut"
    });
    ScrollTrigger.create({
        trigger: '.co-article-s2',
        start: "40% bottom",
        end: "bottom top",
        animation: cAS2Tl1
    });

    const ArticleSec2Swiper = new Swiper('.co-article-s2-swiper', {
        init: false,
        pagination: false,
        watchOverflow: true,
        slidesPerView: 3,
        spaceBetween: 40,

        navigation: {
            nextEl: '.co-article-s2-swiper .swiper-button-next',
            prevEl: '.co-article-s2-swiper .swiper-button-prev',
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            450: {
                slidesPerView: 2,
            },
            989: {
                slidesPerView: 3,
            },
        }
    });

    const parent = document.querySelector('.co-article-s2-swiper .swiper-wrapper');
    const children = Array.from(parent.children);

    // Fisher-Yates Shuffle
    function shuffle(array) {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
    }

    const shuffledChildren = shuffle(children).slice(0, 3);

    // Remove all existing children
    while (parent.firstChild) {
        parent.removeChild(parent.firstChild);
    }

    // Append shuffled children
    shuffledChildren.forEach(child => parent.appendChild(child));

    ArticleSec2Swiper.init();
});